import tw from 'tailwind-styled-components'

export const SectorsContainer = tw.div`
py-10
px-8
`

export const SectorsFilters = tw.form`
flex
gap-2
justify-between
flex-wrap
mb-6
`

export const CreateContainer = tw.form`
flex 
gap-2 
items-center
`